export const SystemActions = {
  SET_APP_BUSY: 'setAppBusy',
  SET_MESSAGE: 'setMessage',
  NAV_HISTORY_ADD: 'navHistoryAdd',
};

export const setAppBusy = (busy) => ({
  type: SystemActions.SET_APP_BUSY,
  payload: busy,
});

export const setMessage = (message) => ({
  type: SystemActions.SET_MESSAGE,
  payload: message,
});

export const historyPush = (path) => ({
  type: SystemActions.NAV_HISTORY_ADD,
  payload: path,
});
